/**
 * CNT-8349: "Aktarmasız" → "Direkt uçuş" A/B testi
 * Kontrol (A): mevcut i18n metinleri | Varyant (B): yeni metinler
 */

// Experiment Platform'da CNT-8349 için oluşturulan dph key ile senkron tutulmalıdır.
export const DIRECT_FLIGHT_LABEL_EXPERIMENT_KEY = 'dph_ca79a71b04289a08'

export const DIRECT_FLIGHT_LABEL_QUERY_OVERRIDE_KEY = 'direct_flight_label_variant'

export const DIRECT_FLIGHT_LABEL_VARIANT_B_OVERRIDES = {
  nonStop: 'Direkt uçuş',
  nonStopMobile: 'Sadece direkt uçuşları göster',
  showOnlyNonStopFlights: 'Sadece direkt uçuşları göster',
} as const

export type DirectFlightLabelVariant = 'A' | 'B'

export function resolveDirectFlightLabelVariant(experiments?: Record<string, string> | null, queryOverride?: string | null): DirectFlightLabelVariant {
  const raw = queryOverride || experiments?.[DIRECT_FLIGHT_LABEL_EXPERIMENT_KEY]
  return raw?.toUpperCase() === 'B' ? 'B' : 'A'
}

/** Query override varsa onu kullanır; yoksa fallback (context/cookie). */
export function resolveDirectFlightLabelVariantFromOverride(queryOverride?: string | null, fallback: DirectFlightLabelVariant = 'A'): DirectFlightLabelVariant {
  const normalized = queryOverride?.toUpperCase()
  if (normalized === 'B') return 'B'
  if (normalized === 'A') return 'A'
  return fallback
}

export function shouldApplyDirectFlightLabelExperiment(market?: string, language?: string): boolean {
  return market === 'tr' || language === 'tr'
}

export function applyDirectFlightLabelExperiment<T extends Record<string, unknown>>(
  endesignLocales: T | null | undefined,
  options: { variant: DirectFlightLabelVariant; market?: string; language?: string }
): T | null | undefined {
  if (!endesignLocales) return endesignLocales
  if (options.variant !== 'B') return endesignLocales
  if (!shouldApplyDirectFlightLabelExperiment(options.market, options.language)) return endesignLocales

  const flightFormTrans = endesignLocales.FlightFormTrans as Record<string, string> | undefined
  if (!flightFormTrans) return endesignLocales

  return {
    ...endesignLocales,
    FlightFormTrans: {
      ...flightFormTrans,
      ...DIRECT_FLIGHT_LABEL_VARIANT_B_OVERRIDES,
    },
  }
}
